import { render, staticRenderFns } from "./EventFooter.vue?vue&type=template&id=dd963172"
import script from "./EventFooter.vue?vue&type=script&lang=js"
export * from "./EventFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports